"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importDefault(require("styled-components"));
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var LinkSC = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  user-select: none;\n\n  font-family: ", ";\n  font-weight: bold;\n  color: ", ";\n\n  will-change: mode, box-shadow;\n  transition: mode, 0.3s, box-shadow 0.3s;\n\n  text-decoration: none;\n\n  :link,\n  :visited {\n    text-decoration: none;\n    color: ", ";\n  }\n\n  :focus,\n  :hover {\n    cursor: pointer;\n    box-shadow: 0 0.0625rem\n      ", ";\n  }\n\n  :active {\n    color: ", ";\n    box-shadow: 0 0.0625rem\n      ", ";\n  }\n\n  &._ndsLink--small {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  &._ndsLink--medium {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  &._ndsLink--large {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  &._ndsLink--disabled {\n    pointer-events: none;\n    color: ", ";\n  }\n"], ["\n  user-select: none;\n\n  font-family: ", ";\n  font-weight: bold;\n  color: ",
    ";\n\n  will-change: mode, box-shadow;\n  transition: mode, 0.3s, box-shadow 0.3s;\n\n  text-decoration: none;\n\n  :link,\n  :visited {\n    text-decoration: none;\n    color: ",
    ";\n  }\n\n  :focus,\n  :hover {\n    cursor: pointer;\n    box-shadow: 0 0.0625rem\n      ",
    ";\n  }\n\n  :active {\n    color: ",
    ";\n    box-shadow: 0 0.0625rem\n      ",
    ";\n  }\n\n  &._ndsLink--small {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  &._ndsLink--medium {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  &._ndsLink--large {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  &._ndsLink--disabled {\n    pointer-events: none;\n    color: ",
    ";\n  }\n"])), function (props) { return props.theme.FontFamilyBase; }, function (p) {
    return p.mode === 'dark' ? p.theme.ColorFontLinkDarkMode : p.theme.ColorFontLinkBase;
}, function (p) {
    return p.mode === 'dark'
        ? p.theme.ColorFontLinkVisitedDarkMode
        : p.theme.ColorFontLinkVisited;
}, function (p) {
    return p.mode === 'dark'
        ? p.theme.ColorUnderlineLinkHoverDarkMode
        : p.theme.ColorUnderlineLinkHover;
}, function (p) {
    return p.mode === 'dark'
        ? p.theme.ColorFontLinkActiveDarkMode
        : p.theme.ColorFontLinkActive;
}, function (p) {
    return p.mode === 'dark'
        ? p.theme.ColorUnderlineLinkActiveDarkMode
        : p.theme.ColorUnderlineLinkActive;
}, function (props) { return props.theme.SizeFontLinkSmall; }, function (props) { return props.theme.SizeLineHeightLinkSmall; }, function (props) { return props.theme.SizeFontLinkMedium; }, function (props) { return props.theme.SizeLineHeightLinkMedium; }, function (props) { return props.theme.SizeFontLinkLarge; }, function (props) { return props.theme.SizeLineHeightLinkLarge; }, function (p) {
    return p.mode === 'dark'
        ? p.theme.ColorFontLinkDisabledDarkMode
        : p.theme.ColorFontLinkDisabled;
});
var Link = function (props) {
    var children = props.children, size = props.size, mode = props.mode, disabled = props.disabled, forwardedRef = props.forwardedRef, classNameProp = props.className, others = __rest(props, ["children", "size", "mode", "disabled", "forwardedRef", "className"]);
    var classNames = clsx_1.default(classNameProp, { '_ndsLink--small': size === 's' }, { '_ndsLink--medium': size === 'm' }, { '_ndsLink--large': size === 'l' }, { '_ndsLink--disabled': disabled });
    return (react_1.default.createElement(LinkSC, __assign({ ref: forwardedRef, mode: mode, className: classNames }, others), children));
};
exports.LinkRootComp = Link;
Link.propTypes = {
    size: prop_types_1.default.oneOf(['s', 'm', 'l']),
    mode: prop_types_1.default.oneOf(['dark', 'light']),
    disabled: prop_types_1.default.bool,
    children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.node]),
    forwardedRef: prop_types_1.default.any,
    className: prop_types_1.default.string
};
Link.defaultProps = {
    size: 'm',
    mode: 'light',
    disabled: false,
    children: null,
    forwardedRef: null,
    className: null
};
exports.default = reactHelpers_1.withForwardedRef(Link);
var templateObject_1;
//# sourceMappingURL=Link.js.map